import store from '../redux/store'
import { addMessage } from '../redux/snackBarState/actions'

const addMessageFunction = (message, options) => {
  store.dispatch(addMessage(message, options))
}

export default addMessageFunction
